/* === blocks.js — theme block library behavior ===
   Vanilla JS. No jQuery dependency. IIFE per block type.
   Phase 1: video facade only. Accordion/tabs/ATC added in later phases.
*/
(function () {
  'use strict';

  /* === Video: YouTube facade ================================== */
  function initYouTubeFacade(root) {
    var nodes = (root || document).querySelectorAll('.bb-video__embed.youtube-facade:not([data-bb-init])');
    Array.prototype.forEach.call(nodes, function (node) {
      node.setAttribute('data-bb-init', '1');
      var btn = node.querySelector('.bb-video__play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = node.getAttribute('data-video-id');
        if (!id) return;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        node.appendChild(iframe);
        node.classList.add('is-playing');
      });
    });
  }

  /* === Accordion: single-open enforcement ==================== */
  function initAccordion(root) {
    var accs = (root || document).querySelectorAll('[data-bb-block="accordion"]:not([data-bb-init])');
    Array.prototype.forEach.call(accs, function (acc) {
      acc.setAttribute('data-bb-init', '1');
      var allowMultiple = acc.getAttribute('data-bb-allow-multiple') === 'true';
      if (allowMultiple) return;
      var items = acc.querySelectorAll('[data-bb-accordion-item]');
      Array.prototype.forEach.call(items, function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          Array.prototype.forEach.call(items, function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  }

  /* === Tabs: ARIA tabs pattern with arrow-key nav ============ */
  function initTabs(root) {
    var groups = (root || document).querySelectorAll('[data-bb-block="tabs"]:not([data-bb-init])');
    Array.prototype.forEach.call(groups, function (group) {
      group.setAttribute('data-bb-init', '1');
      var buttons = group.querySelectorAll('[data-bb-tab-button]');
      var panels  = group.querySelectorAll('[data-bb-tab-panel]');
      if (!buttons.length || !panels.length) return;

      var defaultIndex = parseInt(group.getAttribute('data-bb-default-tab') || '0', 10);
      if (isNaN(defaultIndex) || defaultIndex >= buttons.length) defaultIndex = 0;

      function activate(index) {
        Array.prototype.forEach.call(buttons, function (btn, i) {
          var active = i === index;
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.setAttribute('tabindex', active ? '0' : '-1');
          btn.classList.toggle('is-active', active);
        });
        Array.prototype.forEach.call(panels, function (panel, i) {
          var active = i === index;
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
          panel.classList.toggle('is-active', active);
        });
      }

      Array.prototype.forEach.call(buttons, function (btn, i) {
        var panelId = panels[i] && panels[i].id;
        if (!panelId) {
          panelId = 'bb-tab-panel-' + Math.random().toString(36).slice(2, 9);
          if (panels[i]) panels[i].id = panelId;
        }
        btn.setAttribute('aria-controls', panelId);

        btn.addEventListener('click', function () { activate(i); });
        btn.addEventListener('keydown', function (e) {
          var nextIndex = null;
          if (e.key === 'ArrowRight') nextIndex = (i + 1) % buttons.length;
          else if (e.key === 'ArrowLeft') nextIndex = (i - 1 + buttons.length) % buttons.length;
          else if (e.key === 'Home') nextIndex = 0;
          else if (e.key === 'End') nextIndex = buttons.length - 1;
          if (nextIndex !== null) {
            e.preventDefault();
            activate(nextIndex);
            buttons[nextIndex].focus();
          }
        });
      });

      activate(defaultIndex);
    });
  }

  /* === Variant picker → ATC wiring =========================== */
  function initVariantPicker(root) {
    var pickers = (root || document).querySelectorAll('[data-bb-block="variant-picker"]:not([data-bb-init])');
    Array.prototype.forEach.call(pickers, function (picker) {
      picker.setAttribute('data-bb-init', '1');
      var productId = picker.getAttribute('data-bb-product-id');
      var dataNode = picker.querySelector('[data-bb-variant-data]');
      var selects = picker.querySelectorAll('select[data-bb-option-index]');
      if (!dataNode || !selects.length || !productId) return;

      var variants;
      try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }

      function findMatchingVariant() {
        var values = [];
        Array.prototype.forEach.call(selects, function (sel, i) { values[i] = sel.value; });
        for (var v = 0; v < variants.length; v++) {
          var variant = variants[v];
          var match = true;
          for (var i = 0; i < values.length; i++) {
            if (variant.options[i] !== values[i]) { match = false; break; }
          }
          if (match) return variant;
        }
        return null;
      }

      function updateForms(variant) {
        var inputs = document.querySelectorAll(
          '[data-bb-block="add-to-cart"][data-bb-product-id="' + productId + '"] [data-bb-atc-variant-input]'
        );
        var buttons = document.querySelectorAll(
          '[data-bb-block="add-to-cart"][data-bb-product-id="' + productId + '"] [data-bb-atc-button]'
        );
        Array.prototype.forEach.call(inputs, function (input) {
          input.value = variant ? variant.id : '';
        });
        Array.prototype.forEach.call(buttons, function (btn) {
          var unavailable = !variant || !variant.available;
          if (unavailable) {
            btn.setAttribute('disabled', '');
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
          }
        });
      }

      Array.prototype.forEach.call(selects, function (sel) {
        sel.addEventListener('change', function () {
          updateForms(findMatchingVariant());
        });
      });
    });
  }

  function init(root) {
    var scope = (root && typeof root.querySelectorAll === 'function') ? root : document;
    initYouTubeFacade(scope);
    initAccordion(scope);
    initTabs(scope);
    initVariantPicker(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-init when theme editor adds/loads sections.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
